import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MetaDataService as WaremaMetaDataService } from '@warema/shared/scaffold';
import { MetaRouteKeysWaremaPlus } from '@warema/warema-plus/models';
import { combineLatest, first } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MetaService {
    private readonly _translateService = inject(TranslateService);
    private readonly _metaDataService = inject(WaremaMetaDataService);

    private _currentMetaKey: MetaRouteKeysWaremaPlus | null = null;

    constructor() {
        this._translateService.onLangChange.subscribe(() => {
            if (this._currentMetaKey) {
                this.updateMetaBasedOnMetaRouteKey(this._currentMetaKey);
            }
        });
    }

    public updateMetaBasedOnMetaRouteKey(metaRouteKey: MetaRouteKeysWaremaPlus): void {
        if (!metaRouteKey) {
            metaRouteKey = MetaRouteKeysWaremaPlus.Default;
        }
        this._currentMetaKey = metaRouteKey;

        combineLatest([
            this._translateService.get(`META.${metaRouteKey}.TITLE`),
            this._translateService.get(`META.${metaRouteKey}.DESCRIPTION`),
        ])
            .pipe(first())
            .subscribe(([title, description]) => {
                this._metaDataService.updateTitle(title as string);
                this._metaDataService.updateDescription(description as string);
            });
    }
}
